// Page: savings-intro  (LMI "savings intro" / income-qualification step)
//
// Ported from the inline <script> in
//   Enrollment_modules/info-lmi/savings-intro.module/module.html (lines 454–2001).
//
// MECHANICAL / FAITHFUL PORT — runtime behaviour is preserved. Deliberate changes
// (same family as the pilot, see docs/handoff/global-js-deep-refactor-notes.md):
//   1. Selectors scoped to this module's HubSpot render-time wrapper
//      `#page_1_lmi_widget #child` are now scoped to `root` (the element carrying
//      data-ea-module) where `#child` lives in this module. Whole-widget toggles
//      (`#page_1_lmi_widget`) and cross-widget wrappers (`#page_1_my_info_widget`)
//      stay document-scoped, as in the original. Bare `document.getElementById` /
//      `document.querySelector('.class')` were already document-scoped and stay so.
//   2. `_hcms/api/*` fetches are ROOT-RELATIVE (apiUrl) and same-origin redirects
//      are root-relative ("/my-usage" …) instead of hardcoding
//      https://enrollment.nautilussolar.com. External hosts (aws.nautilussolar.com,
//      api.ipify.org) and *.fs1.hubspotusercontent-na1.net assets are left as-is.
//   3. localStorage goes through core/storage (rawGet/rawSet — the LMI/deal keys
//      aren't in the typed StorageKey union yet; tightening is deferred).
//   4. Inline onclick/ondrop/ondragover handlers are bound in init instead of via
//      HTML attributes (rule G), preserving the exact call arguments.
//
// Dynamic ES5 patterns (var hoisting, HubDB-less deal shapes, vars reassigned
// across types) are typed `any` and `var` is kept where the original used it so
// hoisting semantics match exactly. `Swiper`/`pdfjsLib` are CDN globals; `delay`
// and `incomefileUploadControl` are provided at
// runtime by sibling module inline scripts on the page_1_lmi page (undefined here
// in isolation, exactly as in the original inline <script>). None are declared in
// the theme-root global.d.ts — declared module-locally so the bare references
// compile without editing that shared file (see final report).

import { apiUrl } from "../../core/api"
import * as storage from "../../core/storage"

// Swiper + pdfjsLib are CDN globals declared theme-wide in global.d.ts.
declare const incomefileUploadControl: any
declare const checkValue: any
declare function delay(ms: number): Promise<any>

export function init(root: HTMLElement, _config: unknown): void {
__ea_trace("modules/savings/savings-intro.ts","init",[root,_config],["root","_config"]);
  // implicit globals in the original (bare assigns, no `var`) — declared here so
  // strict-mode ESM doesn't throw ReferenceError.
  let checkedValue: any
  let responseFromAPI: any = ""

  /* loader function */
  function LMIopenLoader() {
__ea_trace("modules/savings/savings-intro.ts","LMIopenLoader",[],[]);
    var loader = document.getElementById("lmILoader") as HTMLElement
    var buttons = document.querySelectorAll("button")
    var anchors = document.querySelectorAll("a")
    ;(document.getElementById("LMIloaderOverlay") as HTMLElement).style.display = "block"
    loader.style.display = "flex"
    buttons.forEach((button) => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[button],["button"]);
      button.disabled = true
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[anchor],["anchor"]);
      ;(anchor as any).disabled = true
    })
  }
  function LMIcloseLoader() {
__ea_trace("modules/savings/savings-intro.ts","LMIcloseLoader",[],[]);
    var loader = document.getElementById("lmILoader") as HTMLElement
    var buttons = document.querySelectorAll("button")
    var anchors = document.querySelectorAll("a")
    ;(document.getElementById("LMIloaderOverlay") as HTMLElement).style.display = "none"
    loader.style.display = "none"
    buttons.forEach((button) => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[button],["button"]);
      button.disabled = false
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[anchor],["anchor"]);
      ;(anchor as any).disabled = false
    })
  }
  /* loader function */

  //index DB
  var request = indexedDB.open("LmiDatabase", 1)
  var db: any
  request.onerror = (event) => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[event],["event"]);
    console.log(`Database error: ${(event.target as any).errorCode}`)
  }
  request.onsuccess = (event) => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[event],["event"]);
    db = (event.target as any).result
    getAllFilesFromIndexedDB()
  }
  request.onupgradeneeded = (event) => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[event],["event"]);
    var db = (event.target as any).result
    var objectStore = db.createObjectStore("files", { autoIncrement: true })
    objectStore.createIndex("name", "name", { unique: false })
  }

  // Function to save file to IndexedDB
  function saveFileToIndexedDB(file: any, checkValue?: any) {
__ea_trace("modules/savings/savings-intro.ts","saveFileToIndexedDB",[file,checkValue],["file","checkValue"]);
    try {
      var reader = new FileReader()
      reader.onload = (event) => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[event],["event"]);
        var arrayBuffer = (event.target as any).result
        var fileObject = {
          name: file.name,
          type: file.type,
          data: arrayBuffer,
          checkValue: checkValue,
        }
        var transaction = db.transaction(["files"], "readwrite")
        var objectStore = transaction.objectStore("files")
        var request = objectStore.put(fileObject)
        request.onerror = (event: any) => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[event],["event"]);
          console.log(`Database error: ${(event.target as any).errorCode}`)
        }
      }
      reader.onerror = (event) => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[event],["event"]);
        console.error("Error reading file:", (event.target as any).error)
      }
      reader.readAsArrayBuffer(file)
    } catch (e) {
    }
  }
  function getAllFilesFromIndexedDB() {
__ea_trace("modules/savings/savings-intro.ts","getAllFilesFromIndexedDB",[],[]);
    var transaction = db.transaction(["files"], "readonly")
    var objectStore = transaction.objectStore("files")
    var filess: any[] = []
    var censusFile: any[] = []
    var incomeFile: any[] = []
    var index = 0

    objectStore.openCursor().onsuccess = (event: any) => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[event],["event"]);
      var cursor = (event.target as any).result
      if (cursor) {
        var fileName = cursor.value.name
        var blobData = cursor.value.data
        var fileType = cursor.value.type
        var file = new File([blobData], fileName, { type: fileType })
        index++
        if (checkValue === "cencus") {
          censusFile.push(file)
        } else if (checkValue === "blue") {
          incomeFile.push(file)
        } else {
          filess.push(file)
        }
        cursor.continue()
      } else {
        if (index !== 0) {
          if (filess.length > 0) {
            handleFilesNew(filess, false)
          }
          if (censusFile.length > 0) {
            handleFilesNew(censusFile, true)
          }
          if (incomeFile.length > 0) {
            handleFilesNew(incomeFile, true)
          }
        }
      }
    }
  }
  // Function to clear the entire IndexedDB database
  function clearDatabase() {
__ea_trace("modules/savings/savings-intro.ts","clearDatabase",[],[]);
    var transaction = db.transaction(db.objectStoreNames, "readwrite")
    transaction.oncomplete = () => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[],[]);
    }
    transaction.onerror = (event: any) => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[event],["event"]);
    }
    Array.from(db.objectStoreNames as any).forEach((storeName: any) => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[storeName],["storeName"]);
      var objectStore = transaction.objectStore(storeName)
      objectStore.clear()
    })
  }
  //End of Indexed Db///

  // --- Go back personal information button ---------------------------------
  ;(root.querySelector("#goback-personal-info") as HTMLElement).addEventListener("click", () => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[],[]);
    var mf = document.querySelector("#page_1_my_info_widget") as HTMLElement
    var lmi = document.querySelector("#page_1_lmi_widget") as HTMLElement
    lmi.style.display = "none"
    mf.style.display = "block"
  })
  // --- Go back personal information button ---------------------------------

  var storedDisplayElementList = JSON.parse(storage.rawGet("displayLMIElementList") as any)
  var storedRequireElementList = JSON.parse(storage.rawGet("requireLMIElementList") as any)
  var SessionLocalStorage = JSON.parse(storage.rawGet("UtilitySessionDetails") as any)
  var shouldValidate = false
  void shouldValidate
  function ShowHide() {
__ea_trace("modules/savings/savings-intro.ts","ShowHide",[],[]);
    var incomdeExceedElement = root.querySelector("#Income_Exceed_Threshold") as HTMLElement
    var programParticipation = root.querySelector("#Program_Participation") as HTMLElement
    var requestIncomCheck = root.querySelector("#Request_Income_Check") as HTMLElement
    if (storedDisplayElementList != null) {
      if (storedDisplayElementList.includes("INCOME EXCEED DISPLAY")) {
        incomdeExceedElement.style.display = "block"
      } else {
        incomdeExceedElement.style.display = "none"
      }

      if (storedDisplayElementList.includes("PROGRAM PARTICIPATION DISPLAY")) {
        programParticipation.style.display = "block"
      } else {
        programParticipation.style.display = "none"
      }
      if (storedDisplayElementList.includes("REQUEST INCOME DISPLAY")) {
        requestIncomCheck.style.display = "block"
      } else {
        requestIncomCheck.style.display = "none"
      }
    }
  }
  ShowHide()

  //Validation
  function RequireNotRequire() {
__ea_trace("modules/savings/savings-intro.ts","RequireNotRequire",[],[]);
    var isValidationSuccess = false
    var incomdeExceedElement = root.querySelector("#Income_Exceed_Threshold") as HTMLElement
    var programParticipation = root.querySelector("#Program_Participation") as HTMLElement
    var requestIncomCheck = root.querySelector("#Request_Income_Check") as HTMLElement
    void incomdeExceedElement
    void programParticipation
    void requestIncomCheck

    var RadioName = document.getElementsByName("color")
    var isAnyChecked = false

    for (var i = 0; i < RadioName.length; i++) {
      if ((RadioName[i] as HTMLInputElement).checked) {
        isAnyChecked = true
        checkedValue = (RadioName[i] as HTMLInputElement).value
        break
      }
    }

    if (!isAnyChecked) {
      ;(root.querySelector("#NoRadioSelected_error_message") as HTMLElement).innerHTML = "Please select an option."
      return false
    } else {
      ;(root.querySelector("#NoRadioSelected_error_message") as HTMLElement).innerHTML = ""

      switch (checkedValue) {
        case "red":
          {
            isValidationSuccess = true
          }
          break
        case "green":
          {
            var tempErrorList: any[] = [validateSelectedOption(), fileFinalButtonValidation(false)]
            if (tempErrorList.includes("error")) {
              isValidationSuccess = false
            } else {
              isValidationSuccess = true
            }
          }
          break
        case "blue":
          {
            if (incomefileUploadControl.name === "Yes") {
              if (listOfIncomeFiles.length === 0) {
                ;(document.getElementById("Income_track_map_upload_error_message") as HTMLElement).textContent =
                  "Please upload file to proceed"
                return
              }
              var tempErrorList: any[] = [fileFinalButtonValidation(false, true)]
              if (tempErrorList.includes("error")) {
                isValidationSuccess = false
              } else {
                isValidationSuccess = true
              }
            } else {
              isValidationSuccess = true
            }
          }
          break
        case "orange":
          {
            var tempErrorList: any[] = [validateCheckSignature()]
            if (tempErrorList.includes("error")) {
              isValidationSuccess = false
            } else {
              isValidationSuccess = true
            }
          }
          break
        case "cencus":
          {
            if (listOfCensusFiles.length === 0) {
              ;(document.getElementById("Cencus_track_map_upload_error_message") as HTMLElement).textContent =
                "Please upload file to proceed"
              return
            }
            var tempErrorList: any[] = [validateCheckCSignature(), fileFinalButtonValidation(true)]
            if (tempErrorList.includes("error")) {
              isValidationSuccess = false
            } else {
              isValidationSuccess = true
            }
          }
          break
      }
    }

    return isValidationSuccess
  }
  /* -- validation --------------------------------- */
  function initSwiper() {
__ea_trace("modules/savings/savings-intro.ts","initSwiper",[],[]);
    swiper = new Swiper(".swiper-container", {
      slidesPerView: "auto",
      spaceBetween: 10,
      navigation: {
        nextEl: "#Program_Participation .swiper-button-next",
        prevEl: "#Program_Participation .swiper-button-prev",
      },
    })
    ;(document.querySelector("#Program_Participation .swiper-button-next") as HTMLElement).innerHTML =
      "<span>Next</span>"
    ;(document.querySelector("#Program_Participation .swiper-button-prev") as HTMLElement).innerHTML =
      "<span>Previous</span>"
  }
  function initCensusSwiper() {
__ea_trace("modules/savings/savings-intro.ts","initCensusSwiper",[],[]);
    censusSwiper = new Swiper(".census-swiper-container", {
      slidesPerView: "auto",
      spaceBetween: 10,
      navigation: {
        nextEl: "#Cencus_tract_map_upload .swiper-button-next",
        prevEl: "#Cencus_tract_map_upload .swiper-button-prev",
      },
    })

    ;(document.querySelector("#Cencus_tract_map_upload .swiper-button-next") as HTMLElement).innerHTML =
      "<span>Next</span>"
    ;(document.querySelector("#Cencus_tract_map_upload .swiper-button-prev") as HTMLElement).innerHTML =
      "<span>Previous</span>"
  }
  function initIncomeSwiper() {
__ea_trace("modules/savings/savings-intro.ts","initIncomeSwiper",[],[]);
    incomeSwiper = new Swiper(".income-swiper-container", {
      slidesPerView: "auto",
      spaceBetween: 10,
      navigation: {
        nextEl: "#Request_Income_Check .swiper-button-next",
        prevEl: "#Request_Income_Check .swiper-button-prev",
      },
    })

    ;(document.querySelector("#Request_Income_Check .swiper-button-next") as HTMLElement).innerHTML =
      "<span>Next</span>"
    ;(document.querySelector("#Request_Income_Check .swiper-button-prev") as HTMLElement).innerHTML =
      "<span>Previous</span>"
  }
  function fileFinalButtonValidation(isUploadCensus?: any, isUploadIncome?: any) {
__ea_trace("modules/savings/savings-intro.ts","fileFinalButtonValidation",[isUploadCensus,isUploadIncome],["isUploadCensus","isUploadIncome"]);
    if (isUploadCensus) {
      var errorMessageElement = document.getElementById("census-file-error-message") as HTMLElement
      var errorMessageStyle = window.getComputedStyle(errorMessageElement)
      if (errorMessageStyle.display === "block" || errorMessageStyle.display === "inline-block") {
        // ok
      } else {
        return "error"
      }
    } else if (isUploadIncome) {
      var errorMessageElement = document.getElementById("Request_Income_Check_error_message") as HTMLElement
      var errorMessageStyle = window.getComputedStyle(errorMessageElement)
      if (errorMessageStyle.display === "block" || errorMessageStyle.display === "inline-block") {
        // ok
      } else {
        return "error"
      }
    } else {
      var errorMessageElement = document.getElementById("file-error-message") as HTMLElement
      var errorMessageStyle = window.getComputedStyle(errorMessageElement)
      if (errorMessageStyle.display === "block" || errorMessageStyle.display === "inline-block") {
        // ok
      } else {
        return "error"
      }
    }
  }
  function captureFromCamera() {
__ea_trace("modules/savings/savings-intro.ts","captureFromCamera",[],[]);
    var inputElement = document.createElement("input")
    inputElement.type = "file"
    inputElement.accept = "image/*"
    ;(inputElement as any).capture = "camera"
    inputElement.addEventListener("change", function (this: HTMLInputElement) {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[this],["this"]);
      handleFilesNew(this.files)
    })

    inputElement.click()
  }
  void captureFromCamera
  function removeImageOpenPopup(isCensus?: any, isIncome?: any) {
__ea_trace("modules/savings/savings-intro.ts","removeImageOpenPopup",[isCensus,isIncome],["isCensus","isIncome"]);
    if (isCensus) {
      ;(document.querySelector(".census-RemoveFilePopup") as HTMLElement).style.display = "block"
    } else if (isIncome) {
      ;(document.querySelector(".income-RemoveFilePopup") as HTMLElement).style.display = "block"
    } else {
      ;(document.querySelector(".RemoveFilePopup") as HTMLElement).style.display = "block"
    }
  }
  function removeCurrentImage(isUploadCensus?: any, isUploadIncome?: any) {
__ea_trace("modules/savings/savings-intro.ts","removeCurrentImage",[isUploadCensus,isUploadIncome],["isUploadCensus","isUploadIncome"]);
    if (isUploadCensus) {
      if (censusSwiper !== undefined) {
        var activeIndex = censusSwiper.activeIndex
        ;(document.getElementById("census-file-error-message") as HTMLElement).innerHTML = ""

        listOfCensusFiles.splice(activeIndex, 1)
        censusSwiper.removeSlide(activeIndex)
        ;(document.getElementById("censusfileCount") as HTMLElement).textContent =
          `Total files selected: ${listOfCensusFiles.length}`

        initCensusSwiper()
        var fileNameDisplay = document.getElementById("censusfileNameDisplay") as HTMLElement
        fileNameDisplay.textContent = `File Name: ${listOfCensusFiles.map((f: any) => f.name).join(", ")}`

        ;(document.querySelector(".census-RemoveFilePopup") as HTMLElement).style.display = "none"
      } else {
      }
    } else if (isUploadIncome) {
      if (incomeSwiper !== undefined) {
        var activeIndex = incomeSwiper.activeIndex
        ;(document.getElementById("Request_Income_Check_error_message") as HTMLElement).innerHTML = ""

        listOfIncomeFiles.splice(activeIndex, 1)
        incomeSwiper.removeSlide(activeIndex)
        ;(document.getElementById("incomefileCount") as HTMLElement).textContent =
          `Total files selected: ${listOfIncomeFiles.length}`

        initIncomeSwiper()
        var fileNameDisplay = document.getElementById("incomefileNameDisplay") as HTMLElement
        fileNameDisplay.textContent = `File Name: ${listOfIncomeFiles.map((f: any) => f.name).join(", ")}`

        ;(document.querySelector(".income-RemoveFilePopup") as HTMLElement).style.display = "none"
      } else {
      }
    } else {
      if (swiper !== undefined) {
        var activeIndex = swiper.activeIndex
        ;(document.getElementById("file-error-message") as HTMLElement).innerHTML = ""

        listOfFiles.splice(activeIndex, 1)
        swiper.removeSlide(activeIndex)
        ;(document.getElementById("fileCount") as HTMLElement).textContent =
          `Total files selected: ${listOfFiles.length}`

        initSwiper()

        var fileNameDisplay = document.getElementById("fileNameDisplay") as HTMLElement
        fileNameDisplay.textContent = `File Name: ${listOfFiles.map((f: any) => f.name).join(", ")}`

        ;(document.querySelector(".RemoveFilePopup") as HTMLElement).style.display = "none"
      } else {
      }
    }
  }

  function removeImageClosePopup(isCensus?: any, isIncome?: any) {
__ea_trace("modules/savings/savings-intro.ts","removeImageClosePopup",[isCensus,isIncome],["isCensus","isIncome"]);
    if (isCensus) {
      ;(document.querySelector(".census-RemoveFilePopup") as HTMLElement).style.display = "none"
    } else if (isIncome) {
      ;(document.querySelector(".census-RemoveFilePopup") as HTMLElement).style.display = "none"
    } else {
      ;(document.querySelector(".RemoveFilePopup") as HTMLElement).style.display = "none"
    }
  }
  function triggerFilePicker() {
__ea_trace("modules/savings/savings-intro.ts","triggerFilePicker",[],[]);
    ;(document.getElementById("file-error-message") as HTMLElement).innerHTML = ""
    ;(document.querySelector("#fileInput") as HTMLElement).click()
  }
  function triggerCensusFilePicker() {
__ea_trace("modules/savings/savings-intro.ts","triggerCensusFilePicker",[],[]);
    ;(document.getElementById("census-file-error-message") as HTMLElement).innerHTML = ""
    ;(document.querySelector("#censusFileInput") as HTMLElement).click()
  }
  function triggerIncomeFilePicker() {
__ea_trace("modules/savings/savings-intro.ts","triggerIncomeFilePicker",[],[]);
    ;(document.getElementById("Request_Income_Check_error_message") as HTMLElement).innerHTML = ""
    ;(document.querySelector("#incomeFileInput") as HTMLElement).click()
  }
  ;(document.getElementById("fileInput") as HTMLElement).addEventListener("change", (event: any) => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[event],["event"]);
    handleFilesNew(event.target.files, false, false)
  })
  ;(document.getElementById("censusFileInput") as HTMLElement).addEventListener("change", (event: any) => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[event],["event"]);
    handleFilesNew(event.target.files, true, false)
  })
  ;(document.getElementById("incomeFileInput") as HTMLElement).addEventListener("change", (event: any) => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[event],["event"]);
    handleFilesNew(event.target.files, false, true)
  })
  function triggerFileInput(event: any, isUploadCensus?: any, isUploadIncome?: any) {
__ea_trace("modules/savings/savings-intro.ts","triggerFileInput",[event,isUploadCensus,isUploadIncome],["event","isUploadCensus","isUploadIncome"]);
    event.preventDefault()
    if (isUploadCensus) {
      ;(document.querySelector('#censusMobileCamera input[type="file"]') as HTMLElement).click()
    } else if (isUploadIncome) {
      ;(document.querySelector('#incomeMobileCamera input[type="file"]') as HTMLElement).click()
    } else {
      ;(document.querySelector('#mobileCamera input[type="file"]') as HTMLElement).click()
    }
  }
  ;(document.getElementById("imageInput") as HTMLElement).addEventListener("change", (event: any) => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[event],["event"]);
    handleFilesNew(event.target.files, false, false)
  })
  ;(document.getElementById("censusImageInput") as HTMLElement).addEventListener("change", (event: any) => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[event],["event"]);
    handleFilesNew(event.target.files, true, false)
  })
  ;(document.getElementById("incomeImageInput") as HTMLElement).addEventListener("change", (event: any) => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[event],["event"]);
    handleFilesNew(event.target.files, false, true)
  })
  function dragOverHandler(event: any, isUploadCensus?: any, isUploadIncome?: any) {
__ea_trace("modules/savings/savings-intro.ts","dragOverHandler",[event,isUploadCensus,isUploadIncome],["event","isUploadCensus","isUploadIncome"]);
    event.preventDefault()
    if (isUploadCensus) {
      ;(root.querySelector("#censusDropArea") as HTMLElement).classList.add("active")
    } else if (isUploadIncome) {
      ;(root.querySelector("#incomeDropArea") as HTMLElement).classList.add("active")
    } else {
      ;(root.querySelector("#dropArea") as HTMLElement).classList.add("active")
    }
  }
  function dropHandler(event: any, isUploadCensus?: any, isUploadIncome?: any) {
__ea_trace("modules/savings/savings-intro.ts","dropHandler",[event,isUploadCensus,isUploadIncome],["event","isUploadCensus","isUploadIncome"]);
    event.preventDefault()
    if (isUploadCensus) {
      ;(root.querySelector("#censusDropArea") as HTMLElement).classList.remove("active")
    } else if (isUploadIncome) {
      ;(root.querySelector("#incomeDropArea") as HTMLElement).classList.remove("active")
    } else {
      ;(root.querySelector("#dropArea") as HTMLElement).classList.remove("active")
    }

    var files = event.dataTransfer.files
    if (isUploadCensus) {
      ;(document.getElementById("census-file-error-message") as HTMLElement).innerHTML = ""
    } else if (isUploadIncome) {
      ;(document.getElementById("Request_Income_Check_error_message") as HTMLElement).innerHTML = ""
    } else {
      ;(document.getElementById("file-error-message") as HTMLElement).innerHTML = ""
    }
    if (files.length > 0) {
      handleFilesNew(files, isUploadCensus, isUploadIncome)
    }
  }
  function browseFiles(isUploadCensus?: any, isUploadIncome?: any) {
__ea_trace("modules/savings/savings-intro.ts","browseFiles",[isUploadCensus,isUploadIncome],["isUploadCensus","isUploadIncome"]);
    var inputElement = document.createElement("input")
    inputElement.type = "file"
    inputElement.accept = "application/pdf, image/*"
    inputElement.addEventListener("change", function (this: HTMLInputElement) {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[this],["this"]);
      handleFilesNew(this.files, isUploadCensus, isUploadIncome)
    })

    inputElement.click()
  }
  void browseFiles
  var _file: any
  void _file
  var isInvalidFileType = false
  void isInvalidFileType
  var isExceededSize = false
  void isExceededSize
  var listOfFiles: any[] = []
  var listOfCensusFiles: any[] = []
  var listOfIncomeFiles: any[] = []
  var swiper: any
  var censusSwiper: any
  var incomeSwiper: any
  function handleFilesNew(files: any, isUploadCensus?: any, isUploadIncome?: any) {
__ea_trace("modules/savings/savings-intro.ts","handleFilesNew",[files,isUploadCensus,isUploadIncome],["files","isUploadCensus","isUploadIncome"]);
    var maxFiles = 12
    var totalfilecount = 0
    if (isUploadCensus) {
      totalfilecount = listOfCensusFiles.length + files.length
    }
    if (isUploadIncome) {
      totalfilecount = listOfIncomeFiles.length + files.length
    } else {
      totalfilecount = listOfFiles.length + files.length
    }

    if (files.length > 0 && totalfilecount <= maxFiles) {
      var allowedTypes = ["application/pdf", "image/jpeg", "image/png", "image/heic", "image/bmp", "image/webp"]

      for (var i = 0; i < files.length; i++) {
        var file = files[i]

        if (!allowedTypes.includes(file.type)) {
          if (isUploadCensus) {
            ;(document.getElementById("census-file-error-message") as HTMLElement).innerHTML =
              "Invalid file type. Please choose valid PDF, PNG, JPEG, HEIC, BMP, or WebP files."
          } else if (isUploadIncome) {
            ;(document.getElementById("Request_Income_Check_error_message") as HTMLElement).innerHTML =
              "Invalid file type. Please choose valid PDF, PNG, JPEG, HEIC, BMP, or WebP files."
          } else {
            ;(document.getElementById("file-error-message") as HTMLElement).innerHTML =
              "Invalid file type. Please choose valid PDF, PNG, JPEG, HEIC, BMP, or WebP files."
          }
          return
        }
      }

      if (file.size > 10 * 1024 * 1024) {
        if (isUploadCensus) {
          ;(document.getElementById("census-file-error-message") as HTMLElement).innerHTML =
            `The total size of selected files exceeds the limit. Please choose files up to 10 MB in total.`
        } else if (isUploadIncome) {
          ;(document.getElementById("Request_Income_Check_error_message") as HTMLElement).innerHTML =
            `The total size of selected files exceeds the limit. Please choose files up to 10 MB in total.`
        } else {
          ;(document.getElementById("file-error-message") as HTMLElement).innerHTML =
            `The total size of selected files exceeds the limit. Please choose files up to 10 MB in total.`
        }
        return
      }
      var fileNameDisplay: any
      var previewContainer: any
      if (isUploadCensus) {
        fileNameDisplay = document.getElementById("censusfileNameDisplay")
        previewContainer = document.getElementById("censusPreviewContainer")
      } else if (isUploadIncome) {
        fileNameDisplay = document.getElementById("incomefileNameDisplay")
        previewContainer = document.getElementById("incomePreviewContainer")
      } else {
        fileNameDisplay = document.getElementById("fileNameDisplay")
        previewContainer = document.getElementById("previewContainer")
      }

      for (var j = 0; j < files.length; j++) {
        var file = files[j]
        var reader = new FileReader()
        var preview = document.createElement("div")
        preview.className = "swiper-slide"
        preview.innerHTML = `<img src="" alt="Preview Image" width="100%" height="auto" id="imageNo${j}">`
        previewContainer.appendChild(preview)

        reader.onload = ((preview, file) => (e: any) => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[e],["e"]);
          if (file.type === "application/pdf") {
            pdfjsLib.getDocument(e.target.result).promise.then((pdf: any) => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[pdf],["pdf"]);
              pdf.getPage(1).then((page: any) => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[page],["page"]);
                var canvas = document.createElement("canvas")
                var context = canvas.getContext("2d")
                var viewport = page.getViewport({ scale: 1.5 })
                canvas.height = viewport.height
                canvas.width = viewport.width
                var renderContext = {
                  canvasContext: context,
                  viewport: viewport,
                }
                page.render(renderContext).promise.then(() => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[],[]);
                  ;(preview.querySelector("img") as HTMLImageElement).src = canvas.toDataURL("image/jpeg")
                })
              })
            })
          } else {
            ;(preview.querySelector("img") as HTMLImageElement).src = e.target.result
          }

          var blobUrl = URL.createObjectURL(file)
          void blobUrl
          if (isUploadCensus) {
            initCensusSwiper()
          } else if (isUploadIncome) {
            initIncomeSwiper()
          } else {
            initSwiper()
          }
        })(preview, file)

        reader.readAsDataURL(file)
        if (isUploadCensus) {
          listOfCensusFiles.push(file)
        } else if (isUploadIncome) {
          listOfIncomeFiles.push(file)
        } else {
          listOfFiles.push(file)
        }
      }

      if (isUploadCensus) {
        ;(document.getElementById("censusfileCount") as HTMLElement).textContent =
          `Total files selected: ${listOfCensusFiles.length}`
        fileNameDisplay.textContent = `File Name: ${listOfCensusFiles.map((f: any) => f.name).join(", ")}`
      } else if (isUploadIncome) {
        ;(document.getElementById("incomefileCount") as HTMLElement).textContent =
          `Total files selected: ${listOfIncomeFiles.length}`
        fileNameDisplay.textContent = `File Name: ${listOfIncomeFiles.map((f: any) => f.name).join(", ")}`
      } else {
        ;(document.getElementById("fileCount") as HTMLElement).textContent =
          `Total files selected: ${listOfFiles.length}`
        fileNameDisplay.textContent = `File Name: ${listOfFiles.map((f: any) => f.name).join(", ")}`
      }
    } else {
      if (isUploadCensus) {
        ;(document.getElementById("census-file-error-message") as HTMLElement).innerHTML =
          `Please select between 1 and ${maxFiles} files.`
      } else if (isUploadIncome) {
        ;(document.getElementById("Request_Income_Check_error_message") as HTMLElement).innerHTML =
          `Please select between 1 and ${maxFiles} files.`
      } else {
        ;(document.getElementById("file-error-message") as HTMLElement).innerHTML =
          `Please select between 1 and ${maxFiles} files.`
      }
    }
  }
  // -- uploaded file to file manager and return file url ---------------------
  var uploadedurl: any[] = []
  void uploadedurl
  async function uploadFileToServer() {
__ea_trace("modules/savings/savings-intro.ts","uploadFileToServer",[],[]);
    clearDatabase()

    const uploadedUrls: any[] = []
    var theList: any
    if (checkedValue === "cencus") {
      theList = listOfCensusFiles
    } else if (checkedValue === "blue") {
      theList = listOfIncomeFiles
    } else {
      theList = listOfFiles
    }

    for (const file of theList) {
      try {
        const formData = new FormData()
        const originalName = file.name

        const safeName = originalName
          .replace(/[\u0000-\u001F\u007F-\u009F]/g, "")
          .replace(/[^\x00-\x7F]/g, "")
          .replace(/\s+/g, " ")

        formData.append("file", file, safeName)
        formData.append("name", safeName)

        const requestOptions = {
          method: "POST",
          body: formData,
        }

        // External file-manager endpoint (aws.nautilussolar.com) — not a HubSpot
        // serverless function, so left as an absolute URL.
        const response = await fetch("https://aws.nautilussolar.com/testRoute/uploadFileToFileManager", requestOptions)
        responseFromAPI = await response.json()
        if (response.ok) {
          saveFileToIndexedDB(file, checkedValue)
          uploadedUrls.push(responseFromAPI.response.url)
        } else {
          throw new Error("Error uploading file")
        }
      } catch (error) {
        throw error
      }
    }
    return uploadedUrls
  }

  // -- uploaded file to file manager -----------------------------------------
  function removeAllImages() {
__ea_trace("modules/savings/savings-intro.ts","removeAllImages",[],[]);
    ;(document.getElementById("file-error-message") as HTMLElement).innerHTML = ""

    listOfFiles = []

    while (swiper.slides.length > 0) {
      swiper.removeSlide(0)
    }

    ;(document.getElementById("fileCount") as HTMLElement).textContent = `Total files selected: ${listOfFiles.length}`

    initSwiper()

    var fileNameDisplay = document.getElementById("fileNameDisplay") as HTMLElement
    fileNameDisplay.textContent = "File Name: "
  }
  void removeAllImages
  // append selected option's value below selectbox ----------
  var optns = root.querySelector("#incomeThreshold-options") as HTMLSelectElement
  var replacementDiv = root.querySelector("#appendDocument") as HTMLElement
  var selectedProgramSelection = ""
  optns.addEventListener("change", () => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[],[]);
    var selectedValue = optns.value
    var selectedOption = optns.options[optns.selectedIndex]
    selectedProgramSelection = selectedOption.textContent as string
    var selectedOptionValue = selectedValue
    if (selectedOptionValue !== "") {
      const filesArray = selectedOptionValue.split(",").map((file) => file.trim())
      const selectBox = document.querySelector(
        "#page_1_lmi_widget #appendDocument #programFilesOptions",
      ) as HTMLSelectElement
      selectBox.innerHTML = '<option selected="" disabled="">Select an option</option>'

      /* ------------- lmi database removed  --------- */
      removeCurrentImage(false)

      filesArray.forEach((file) => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[file],["file"]);
        const option = document.createElement("option")
        option.value = file
        option.textContent = file
        selectBox.appendChild(option)
      })
      replacementDiv.innerHTML = ""
      replacementDiv.appendChild(selectBox)
    } else {
      replacementDiv.innerHTML = ""
    }
  })
  // append selected option's value below selectbox ----------
  ;(root.querySelector("#incomeThreshold-options") as HTMLElement).addEventListener("change", () => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[],[]);
    validateSelectedOption()
  })

  ;(root.querySelector("#programFilesOptions") as HTMLElement).addEventListener("change", () => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[],[]);
    validateSelectedOption()
  })

  function getCurrentTimestamp() {
__ea_trace("modules/savings/savings-intro.ts","getCurrentTimestamp",[],[]);
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, "0")
    const day = String(now.getDate()).padStart(2, "0")
    const hours = String(now.getHours()).padStart(2, "0")
    const minutes = String(now.getMinutes()).padStart(2, "0")
    const seconds = String(now.getSeconds()).padStart(2, "0")
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
  }
  void getCurrentTimestamp
  var ipAddress = ""
  async function getPublicIP() {
__ea_trace("modules/savings/savings-intro.ts","getPublicIP",[],[]);
    try {
      const response = await fetch("https://api.ipify.org?format=json")
      const data = await response.json()
      ipAddress = data.ip
    } catch (error) {
      console.error("Error fetching public IP:", error)
    }
  }

  // add data to deal --------------------------------
  async function addLMIDataToDealRecord(programParticipation?: any, url?: any) {
__ea_trace("modules/savings/savings-intro.ts","addLMIDataToDealRecord",[programParticipation,url],["programParticipation","url"]);
    await getPublicIP()
    var lmiFile1,
      lmiFile2,
      lmiFile3,
      lmiFile4,
      lmiFile5,
      lmiFile6,
      lmiFile7,
      lmiFile8,
      lmiFile9,
      lmiFile10,
      lmiFile11,
      lmiFile12
    if (url !== undefined) {
      if (url[0]) {
        lmiFile1 = url[0]
      } else {
        lmiFile1 = ""
      }
      if (url[1]) {
        lmiFile2 = url[1]
      } else {
        lmiFile2 = ""
      }
      if (url[2]) {
        lmiFile3 = url[2]
      } else {
        lmiFile3 = ""
      }
      if (url[3]) {
        lmiFile4 = url[3]
      } else {
        lmiFile4 = ""
      }
      if (url[4]) {
        lmiFile5 = url[4]
      } else {
        lmiFile5 = ""
      }
      if (url[5]) {
        lmiFile6 = url[5]
      } else {
        lmiFile6 = ""
      }
      if (url[6]) {
        lmiFile7 = url[6]
      } else {
        lmiFile7 = ""
      }
      if (url[7]) {
        lmiFile8 = url[7]
      } else {
        lmiFile8 = ""
      }
      if (url[8]) {
        lmiFile9 = url[8]
      } else {
        lmiFile9 = ""
      }
      if (url[9]) {
        lmiFile10 = url[9]
      } else {
        lmiFile10 = ""
      }
      if (url[10]) {
        lmiFile11 = url[10]
      } else {
        lmiFile11 = ""
      }
      if (url[11]) {
        lmiFile12 = url[11]
      } else {
        lmiFile12 = ""
      }
    } else {
      lmiFile1 = ""
      lmiFile2 = ""
      lmiFile3 = ""
      lmiFile4 = ""
      lmiFile5 = ""
      lmiFile6 = ""
      lmiFile7 = ""
      lmiFile8 = ""
      lmiFile9 = ""
      lmiFile10 = ""
      lmiFile11 = ""
      lmiFile12 = ""
    }
    var lmioptionvalue
    var incomeThreeshold = root.querySelector("#income-threshold-radio") as HTMLInputElement
    var programParticipationRadio = root.querySelector("#program-participation-radio") as HTMLInputElement
    var requestIncome = root.querySelector("#request-icome-radio") as HTMLInputElement
    var attestation = root.querySelector("#attestation-radio") as HTMLInputElement
    var attestationLMICheckboxContent: any = root.querySelector("#LMICheckboxContent") as HTMLInputElement
    var attestationelctsign: any = (root.querySelector("#elctsign") as HTMLInputElement).value
    var cencusTrackradio = root.querySelector("#cencus-track-radio") as HTMLInputElement
    var lmiofferId = storage.rawGet("offerIdYesLMI")
    var psvrMulti = "LMI Review"
    if (incomeThreeshold.checked) {
      lmioptionvalue = "Threshold Opt-Out"
      lmiofferId = storage.rawGet("offerIdNoLMI")
      psvrMulti = ""
    }
    if (programParticipationRadio.checked) {
      lmioptionvalue = "Program"
      if (selectedProgramSelection === "") {
        selectedProgramSelection === ""
      }
    }
    if (requestIncome.checked) {
      lmioptionvalue = "Income Verification"
    }
    if (attestation.checked) {
      lmioptionvalue = "Attestation"
    }

    if (programParticipation === "") {
      programParticipation = ""
    }
    if (attestationLMICheckboxContent.checked) {
      attestationLMICheckboxContent = "Yes"
    } else {
      attestationLMICheckboxContent = "No"
    }

    if (cencusTrackradio.checked) {
      lmioptionvalue = "Census Tract Map Upload"
      attestationelctsign = (root.querySelector("#celctsign") as HTMLInputElement).value
      if (attestationelctsign) {
        // ok
      } else {
        attestationelctsign === ""
      }
      attestationLMICheckboxContent = root.querySelector("#cLMICheckboxContent") as HTMLInputElement
      if (attestationLMICheckboxContent.checked) {
        attestationLMICheckboxContent = "Yes"
      } else {
        attestationLMICheckboxContent = "No"
      }
    }
    const timestamp = new Date().toISOString()
    var dealId = storage.rawGet("dealId")
    var catchdata: any = ""
    if (requestIncome.checked) {
      try {
        const data = {
          properties: {
            deal_id: dealId,
            lmi_option: lmioptionvalue,
            lmi_attest_confirmation: attestationLMICheckboxContent,
            lmi_signature: attestationelctsign,
            lmi_program_doc_url_1: "",
            lmi_program_doc_url_2: "",
            lmi_program_doc_url_3: "",
            lmi_program_doc_url_4: "",
            lmi_program_doc_url_5: "",
            lmi_program_doc_url_6: "",
            lmi_program_doc_url_7: "",
            lmi_program_doc_url_8: "",
            lmi_program_doc_url_9: "",
            lmi_program_doc_url_10: "",
            lmi_program_doc_url_11: "",
            lmi_program_doc_url_12: "",
            income_verification_doc_file_1: lmiFile1,
            lmi_program_selection: selectedProgramSelection,
            lmi_program_doc_selection: selectedOptText,
            lmi_my_usage: "yes",
            lmi_file_timestamp: timestamp,
            lmi_ip_address: ipAddress,
            post_submission_verification_reason_multi: psvrMulti,
          },
        }
        const response = await fetch(apiUrl("UpdateDealRecord"), {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        })
        if (response.ok) {
          checkconcentvariation(lmioptionvalue)
        }
        catchdata = data
        const result = await response.json()
        responseFromAPI = JSON.stringify(result)
      } catch (error) {
        LMIcloseLoader()
        console.error("Error:", error)
      }
    } else {
      try {
        const data = {
          properties: {
            deal_id: dealId,
            lmi_option: lmioptionvalue,
            lmi_attest_confirmation: attestationLMICheckboxContent,
            lmi_signature: attestationelctsign,
            lmi_program_doc_url_1: lmiFile1,
            lmi_program_doc_url_2: lmiFile2,
            lmi_program_doc_url_3: lmiFile3,
            lmi_program_doc_url_4: lmiFile4,
            lmi_program_doc_url_5: lmiFile5,
            lmi_program_doc_url_6: lmiFile6,
            lmi_program_doc_url_7: lmiFile7,
            lmi_program_doc_url_8: lmiFile8,
            lmi_program_doc_url_9: lmiFile9,
            lmi_program_doc_url_10: lmiFile10,
            lmi_program_doc_url_11: lmiFile11,
            lmi_program_doc_url_12: lmiFile12,
            income_verification_doc_file_1: "",
            lmi_program_selection: selectedProgramSelection,
            lmi_program_doc_selection: selectedOptText,
            lmi_my_usage: "yes",
            lmi_file_timestamp: timestamp,
            lmi_ip_address: ipAddress,
            product_offer_id: lmiofferId,
            post_submission_verification_reason_multi: psvrMulti,
          },
        }
        const response = await fetch(apiUrl("UpdateDealRecord"), {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        })
        if (response.ok) {
          checkconcentvariation(lmioptionvalue)
        }
        catchdata = data
        const result = await response.json()
        responseFromAPI = JSON.stringify(result)
      } catch (error) {
        LMIcloseLoader()
        console.error("Error:", error)
      }
    }
  }
  // add data to deal --------------------------------

  // Save my place button --------------------------------
  async function SaveButton(programParticipation?: any, url?: any) {
__ea_trace("modules/savings/savings-intro.ts","SaveButton",[programParticipation,url],["programParticipation","url"]);
    void url
    var lmioptionvalue
    var incomeThreeshold = root.querySelector("#income-threshold-radio") as HTMLInputElement
    var programParticipationRadio = root.querySelector("#program-participation-radio") as HTMLInputElement
    var requestIncome = root.querySelector("#request-icome-radio") as HTMLInputElement
    var attestation = root.querySelector("#attestation-radio") as HTMLInputElement
    var attestationLMICheckboxContent: any = root.querySelector("#LMICheckboxContent") as HTMLInputElement
    var attestationelctsign = (root.querySelector("#elctsign") as HTMLInputElement).value
    if (incomeThreeshold.checked) {
      lmioptionvalue = "Threshold Opt-Out"
    }
    if (programParticipationRadio.checked) {
      lmioptionvalue = "Program"
    }
    if (requestIncome.checked) {
      lmioptionvalue = "Income Verification"
    }
    if (attestation.checked) {
      lmioptionvalue = "Attestation"
    }
    if (programParticipation === "") {
      programParticipation = ""
    }
    if (attestationLMICheckboxContent.checked) {
      attestationLMICheckboxContent = "Yes"
    } else {
      attestationLMICheckboxContent = "No"
    }
    var dealId = storage.rawGet("dealId")
    var catchdata: any = ""
    try {
      const data = {
        properties: {
          deal_id: dealId,
          lmi_option: lmioptionvalue,
          lmi_attest_confirmation: attestationLMICheckboxContent,
          lmi_signature: attestationelctsign,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
      if (response.ok) {
        // ok
      }
      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
      catchdata = data
    } catch (error) {
      console.error("Error:", error)
    }
  }

  ;(root.querySelector("#save-remind") as HTMLElement).addEventListener("click", () => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[],[]);
    var incomeThreesholdd = root.querySelector("#income-threshold-radio") as HTMLInputElement
    var requestIncomee = root.querySelector("#request-icome-radio") as HTMLInputElement
    var attestationRadio = root.querySelector("#attestation-radio") as HTMLInputElement
    if (incomeThreesholdd.checked || requestIncomee.checked || attestationRadio.checked) {
      SaveButton(selectedValue)
    } else {
      ;(async () => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[],[]);
        try {
          const url = await uploadFileToServer()
          SaveButton(selectedValue, url)
        } catch (error) {
        }
      })()
    }
  })
  // Save my place button  --------------------------------

  // append selected option's value below selectbox ----------
  optns = root.querySelector("#incomeThreshold-options") as HTMLSelectElement
  var optns2 = root.querySelector("#programFilesOptions") as HTMLSelectElement
  var selectedValue: any = ""
  var selectedOptText: any = ""
  optns.addEventListener("change", () => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[],[]);
    selectedValue = optns.options[optns.selectedIndex]
    selectedValue = selectedValue.innerText
  })

  optns2.addEventListener("change", () => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[],[]);
    selectedOptText = optns2.value
  })
  // append selected option's value below selectbox ----------

  // update Deal Stage -----------------------------------------------------------
  async function updateDealStageLMI(value?: any) {
__ea_trace("modules/savings/savings-intro.ts","updateDealStageLMI",[value],["value"]);
    var dealId = storage.rawGet("dealId")
    await delay(2000)
    var catchdata: any = ""
    try {
      const data = {
        properties: {
          deal_id: dealId,
          dealstage: value,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })

      if (response.ok) {
      }
      catchdata = data
      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      console.error("Error:", error)
    }
    return true
  }
  //- update deaLstage -----------------------------------------------------------

  // checkConsentElementVariation ------------------------------------------------
  async function checkconcentvariation(lmioptionvalue?: any) {
__ea_trace("modules/savings/savings-intro.ts","checkconcentvariation",[lmioptionvalue],["lmioptionvalue"]);
    var UsageDisplayElementList = JSON.parse(storage.rawGet("usageDisplayelementList") as any)
    var consentDisplayelementList = JSON.parse(storage.rawGet("consentDisplayelementList") as any)
    if (UsageDisplayElementList.length > 1) {
      await updateDealStageLMI("127892569")
      LMIcloseLoader()
      var cp = storage.rawGet("credentialProvider")
      if (cp === "NSE (Hansen)" && lmioptionvalue === "Threshold Opt-Out") {
        window.location.href = "/my-usage" // redirect to normal hansen myusage page
      } else if (cp === "Bayou" && lmioptionvalue === "Threshold Opt-Out") {
        window.location.href = "/myusage" // redirect to normal bayou myusage page
      } else if (cp === "NSE (Hansen)") {
        window.location.href = "/my-usage-lh" // redirect to lmi hansen myusage page
      } else if (cp === "Bayou") {
        window.location.href = "/my_usage" // redirect to lmi bayou myusage page
      } else {
        window.location.href = "/my-usage"
      }
    } else if (consentDisplayelementList.length > 0) {
      if (SessionLocalStorage["33"] === "1") {
        await updateDealStageLMI("127892568")
        LMIcloseLoader()
        storage.rawSet("rp", "QxtVq")
        window.location.href = "/my-consent"
      } else if (SessionLocalStorage["33"] === "0") {
        await updateDealStageLMI("127892567")
        LMIcloseLoader()
        storage.rawSet("rp", "NpEv")
        window.location.href = "/my-consent"
      } else {
        await updateDealStageLMI("127892567")
        LMIcloseLoader()
        storage.rawSet("rp", "NpEv")
        window.location.href = "/my-consent"
      }
    }
  }
  // checkConsentElementVariation ------------------------------------------------

  ;(root.querySelector("#get-utility-info") as HTMLElement).addEventListener("click", () => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[],[]);
    LMIopenLoader()
    var isvalidated = RequireNotRequire()
    if (isvalidated) {
      var incomeThreesholdd = root.querySelector("#income-threshold-radio") as HTMLInputElement
      var requestIncomee = root.querySelector("#request-icome-radio") as HTMLInputElement
      var attestationRadio = root.querySelector("#attestation-radio") as HTMLInputElement
      if (incomeThreesholdd.checked || attestationRadio.checked) {
        addLMIDataToDealRecord(selectedValue)
      } else if (requestIncomee.checked) {
        if (incomefileUploadControl.name !== "Yes") {
          addLMIDataToDealRecord(selectedValue)
        } else {
          ;(async () => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[],[]);
            try {
              const url = await uploadFileToServer()
              if (Array.isArray(url) && url.length === 0) {
                ;(root.querySelector("#file-error-message") as HTMLElement).innerHTML = "Please upload an file."
                LMIcloseLoader()
              } else {
                ;(root.querySelector("#file-error-message") as HTMLElement).innerHTML = ""
                addLMIDataToDealRecord(selectedValue, url)
              }
            } catch (error) {
              addLMIDataToDealRecord(selectedValue)
            }
          })()
        }
      } else {
        ;(async () => {
__ea_trace("modules/savings/savings-intro.ts","(anon)",[],[]);
          try {
            const url = await uploadFileToServer()
            if (Array.isArray(url) && url.length === 0) {
              ;(root.querySelector("#file-error-message") as HTMLElement).innerHTML = "Please upload an file."
              LMIcloseLoader()
            } else {
              ;(root.querySelector("#file-error-message") as HTMLElement).innerHTML = ""
              addLMIDataToDealRecord(selectedValue, url)
            }
          } catch (error) {
            addLMIDataToDealRecord(selectedValue)
          }
        })()
      }
    } else {
      LMIcloseLoader()
    }
  })

  function validateSelectedOption() {
__ea_trace("modules/savings/savings-intro.ts","validateSelectedOption",[],[]);
    var selectedOption = (root.querySelector("#incomeThreshold-options") as HTMLSelectElement).value
    var selectedOption1 = (root.querySelector("#programFilesOptions") as HTMLSelectElement).value
    var optionError = root.querySelector("#optionError") as HTMLElement
    var optionError1 = root.querySelector("#optionError1") as HTMLElement

    if (selectedOption === "Select an option") {
      optionError.innerHTML = "Please select an option."
      return "error"
    } else {
      optionError.innerHTML = ""
      if (selectedOption1 === "Select an option") {
        optionError1.innerHTML = "Please select an option."
        return "error"
      } else {
        optionError1.innerHTML = ""
        return null
      }
    }
  }
  function validateCheckSignature() {
__ea_trace("modules/savings/savings-intro.ts","validateCheckSignature",[],[]);
    var LMICheckboxContent = root.querySelector("#LMICheckboxContent") as HTMLInputElement
    var elctsign = (root.querySelector("#elctsign") as HTMLInputElement).value
    var attestation_error = root.querySelector("#attestation_error_message") as HTMLElement
    if (!LMICheckboxContent.checked || elctsign === "" || elctsign === " " || elctsign == null) {
      attestation_error.innerHTML = "There are errors in the form above. Please scroll up and correct them to continue"
      return "error"
    } else {
      attestation_error.innerHTML = ""
      return null
    }
  }

  function validateCheckCSignature() {
__ea_trace("modules/savings/savings-intro.ts","validateCheckCSignature",[],[]);
    var cLMICheckboxContent = root.querySelector("#cLMICheckboxContent") as HTMLInputElement
    var celctsign = (root.querySelector("#celctsign") as HTMLInputElement).value
    var census_error = root.querySelector("#census-file-error-message") as HTMLElement

    if (!cLMICheckboxContent.checked || celctsign === "" || celctsign === " " || celctsign == null) {
      census_error.innerHTML = "Please complete required fields"
      return "error"
    } else {
      census_error.innerHTML = ""
      return null
    }
  }
  function toggleContent(radio: any) {
__ea_trace("modules/savings/savings-intro.ts","toggleContent",[radio],["radio"]);
    var itemsContainer = document.querySelector(".ipiaap-items") as HTMLElement
    var itemsContainer1 = document.querySelector(".ipiaap-items-1") as HTMLElement
    var itemsContainer2 = document.querySelector(".ipiaap-items-2") as HTMLElement
    var itemsContainer3 = document.querySelector(".ipiaap-items-3") as HTMLElement
    itemsContainer.style.display = radio.value === "green" ? "block" : "none"
    itemsContainer1.style.display = radio.value === "orange" ? "block" : "none"
    itemsContainer2.style.display = radio.value === "cencus" ? "block" : "none"
    itemsContainer3.style.display = radio.value === "blue" ? "block" : "none"
    if (incomefileUploadControl.name !== "Yes") {
      itemsContainer3.style.display = "none"
    }
  }
  /* -- validation --------------------------------- */

  // ─── wire the (formerly inline) handlers (rule G) ────────────────────────────
  const bind = (sel: string, type: string, fn: (e: any) => void) => {
__ea_trace("modules/savings/savings-intro.ts","bind",[sel,type,fn],["sel","type","fn"]);
    const el = root.querySelector(sel)
    if (el) el.addEventListener(type, fn)
  }

  // radios → toggleContent(this)
  ;[
    "#income-threshold-radio",
    "#program-participation-radio",
    "#cencus-track-radio",
    "#request-icome-radio",
    "#attestation-radio",
  ].forEach((sel) => bind(sel, "click", (e) => toggleContent(e.currentTarget)))

  // program (non-census/income) upload group
  bind("#dropArea", "drop", (e) => dropHandler(e, false))
  bind("#dropArea", "dragover", (e) => dragOverHandler(e, false))
  bind("#dropArea", "click", () => triggerFilePicker())
  bind("#mobileCamera img", "click", (e) => triggerFileInput(e, false))
  bind("#mobileCamera a", "click", (e) => triggerFileInput(e, false))
  bind("#Program_Participation .uploadRemoveButtons button:not([id])", "click", () => triggerFilePicker())
  bind("#removeimagebutton", "click", () => removeImageOpenPopup(false))
  bind(".RemoveFilePopup .removefilePopButtons button:not([id])", "click", () => removeCurrentImage(false))
  bind("#keepIt", "click", () => removeImageClosePopup(false))

  // census upload group
  bind("#censusDropArea", "drop", (e) => dropHandler(e, true, false))
  bind("#censusDropArea", "dragover", (e) => dragOverHandler(e, true, false))
  bind("#censusDropArea", "click", () => triggerCensusFilePicker())
  bind("#censusMobileCamera img", "click", (e) => triggerFileInput(e, true, false))
  bind("#censusMobileCamera a", "click", (e) => triggerFileInput(e, true, false))
  bind("#Cencus_tract_map_upload .uploadRemoveButtons button:not([id])", "click", () => triggerCensusFilePicker())
  bind("#censusRemoveimagebutton", "click", () => removeImageOpenPopup(true, false))
  bind(".census-RemoveFilePopup .removefilePopButtons button:not([id])", "click", () => removeCurrentImage(true, false))
  bind(".census-RemoveFilePopup #keepItt", "click", () => removeImageClosePopup(true, false))

  // income upload group
  bind("#incomeDropArea", "drop", (e) => dropHandler(e, false, true))
  bind("#incomeDropArea", "dragover", (e) => dragOverHandler(e, false, true))
  bind("#incomeDropArea", "click", () => triggerIncomeFilePicker())
  bind("#incomeMobileCamera img", "click", (e) => triggerFileInput(e, false, true))
  bind("#incomeMobileCamera a", "click", (e) => triggerFileInput(e, false, true))
  bind("#Request_Income_Check .uploadRemoveButtons button:not([id])", "click", () => triggerIncomeFilePicker())
  bind("#incomeRemoveimagebutton", "click", () => removeImageOpenPopup(false, true))
  bind(".income-RemoveFilePopup .removefilePopButtons button:not([id])", "click", () => removeCurrentImage(false, true))
  bind(".income-RemoveFilePopup #keepItt", "click", () => removeImageClosePopup(false, true))
}
